import React from 'react';
import { createRoot } from 'react-dom/client';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import './index.css';
import App from './App';
import keycloak from './keycloak';
import { Provider } from 'react-redux';
import { store } from './redux/store'; // ← your Redux store
import { ENV } from './config';
import { initRUM } from './observability/faro';
import FaroErrorBoundary from './observability/FaroErrorBoundary';

// Initialize RUM before render so early errors/web-vitals are captured. No-op
// when REACT_APP_FARO_URL is empty (local dev).
initRUM({
  appName: ENV.REACT_APP_FARO_APP_NAME || 'kra-setup',
  environment: ENV.REACT_APP_ENVIRONMENT,
  collectorUrl: ENV.REACT_APP_FARO_URL,
  apiAllowedUrls: [ENV.REACT_APP_REST_API, ENV.REACT_APP_CENTRAL_AUTH],
  version: process.env.REACT_APP_VERSION || '1.0.0',
  sessionSampleRate: Number(ENV.REACT_APP_FARO_SAMPLE_RATE ?? 1),
});

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <FaroErrorBoundary>
    <Provider store={store}>
      <ReactKeycloakProvider authClient={keycloak}>
        <App />
      </ReactKeycloakProvider>
    </Provider>
  </FaroErrorBoundary>
);

